/**
 * Rider theme tokens, sampled from Gogoro Nepal (gogoronp-nebula.com) and
 * LoopX (loopx.com.np) brand palettes:
 *
 *   --color-green:        #c0df16  (Gogoro electric lime)
 *   --color-dark-green:   #00b946  (Gogoro success green)
 *   --color-blue:         #00d7ff  (Gogoro electric cyan)
 *   --color-midnight:     #121215  (Gogoro near-black)
 *   --color-red:          #ff1923  (Gogoro alert)
 *   LoopX --primary-color #00D4AA  (LoopX aqua)
 *
 * Distinct from the Khalti modal's cream/purple palette — Khalti owns its own
 * brand, so its tokens stay co-located with that component. Pack purchase,
 * wallet, and other rider surfaces share this palette.
 */

export type RiderTokens = {
  surface: {
    sheet: string;
    sheetEdge: string;
    raised: string;
    raisedSelected: string;
    inputIdle: string;
    edge: string;
    edgeStrong: string;
  };
  text: {
    primary: string;
    muted: string;
    faint: string;
    inverse: string;
  };
  accent: {
    lime: string;
    limeDeep: string;
    aqua: string;
    aquaDeep: string;
    alert: string;
    ok: string;
    info: string;
  };
  cta: {
    bg: string;
    bgHover: string;
    text: string;
    border: string;
  };
  glow: {
    selection: string;
    selectionLime: string;
  };
};

export const riderLight: RiderTokens = {
  surface: {
    sheet: '#FFFFFF',
    sheetEdge: '#FAFAF7',
    raised: '#FFFFFF',
    raisedSelected: 'rgba(192, 223, 22, 0.07)',
    inputIdle: '#F7F8F4',
    edge: 'rgba(18, 18, 21, 0.08)',
    edgeStrong: 'rgba(18, 18, 21, 0.20)',
  },
  text: {
    primary: '#121215',
    muted: 'rgba(18, 18, 21, 0.62)',
    faint: 'rgba(18, 18, 21, 0.42)',
    inverse: '#FFFFFF',
  },
  accent: {
    lime: '#c0df16',
    limeDeep: '#99b310',
    aqua: '#00D4AA',
    aquaDeep: '#009f7f',
    alert: '#ff1923',
    ok: '#00b946',
    info: '#00d7ff',
  },
  cta: {
    bg: '#121215',
    bgHover: '#1F1F25',
    text: '#FFFFFF',
    border: 'rgba(255, 255, 255, 0.08)',
  },
  glow: {
    selection: 'rgba(18, 18, 21, 0.10)',
    selectionLime: 'rgba(192, 223, 22, 0.30)',
  },
};

// Cast helper used inside styled-components template literals. Keeps the
// global DefaultTheme augmentation (owned by KhaltiTopupModal) from polluting
// the rider theme shape — and vice versa.
export const r = (theme: unknown): RiderTokens => theme as RiderTokens;
